import styled from 'styled-components'

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
  flex-direction: column;
  justify-content: center;
  margin-top: ${props => props.theme.whiteLabel.spacing.sp24};
`
